// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod-2.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// @ts-ignore
const ENV = window['env'];

export const environment = {
  version: '2.3.3',
  production: ENV.PRODUCTION,
  isLocally: ENV.IS_LOCALLY,
  apiUrl: `${ENV.API_UPL}`,
  brandTitle: `${ENV.BRAND_TITLE}`,
  brand: `${ENV.BRAND}`,
  links: {
    brandHome: `${ENV.BRAND_HOME}`,
    supportCentr: `https://${ENV.SUPPORT}/`,
    privacy: `https://${ENV.BRAND_HOME_DOMAIN}/${ENV.BRAND_PRIVACY}/`,
    termsOfUse: `${ENV.BRAND_TERMS_OF_USE}/`,
    signUp: `https://${ENV.BRAND_HOME_DOMAIN}/account/login/`,
    showSignUp: ENV.SHOW_SIGN_UP,
  },
};
